import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import { formatPln } from '../catalog/money';
import { transportOptionLabel, type TransportOption } from './transport';

/** A service of the price list as `GET /api/pricing/search?only=service` sends it (price only when visible). */
export type ServiceHit = { id: string; name: string; priceGrosze?: number | null; transport?: 'truck' | 'car' | null };

/**
 * The services a fixed section offers (P8, note 22:46): transports in "Transport", the others in "Obsługa" — for its
 * "+ Usługa" / "+ Transport" and (owner 2026-10-24 16:15) for a line of it replaced in place. A transport is labelled
 * with the price it will get (owner 2026-10-23 10:32: the event's km now, the threshold).
 */
export function useFixedServices(versionId: string, transport: boolean) {
  const services = useQuery({ queryKey: ['pricing', 'services-pick'], queryFn: () => api<{ hits: ServiceHit[] }>('/api/pricing/search?only=service&limit=200'), staleTime: 60_000 });
  const options = useQuery({
    queryKey: ['quotes', 'transport-options', versionId],
    enabled: transport,
    staleTime: 0,
    queryFn: () => api<{ options: TransportOption[] }>(`/api/quotes/versions/${versionId}/transport-options`),
  });
  const optionOf = new Map((options.data?.options ?? []).map((o) => [o.serviceId, o]));
  const list = (services.data?.hits ?? []).filter((h) => (h.transport != null) === transport);
  // review M2: a transport shows only its name until its options come (the price list's price is only the flat amount)
  const labelOf = (h: ServiceHit) => (transport ? transportOptionLabel(h.name, optionOf.get(h.id)) : typeof h.priceGrosze === 'number' ? `${h.name} · ${formatPln(h.priceGrosze)}` : h.name);
  return { ready: services.isSuccess, list, labelOf };
}

/** „Inne” (owner 19:55): an own line of a fixed section, its name to type in the row, its price 0 until then. */
export const OTHER_TITLE = 'Pozycja własna w tej sekcji: wpisz nazwę i cenę w wierszu';
